var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"recipe-card",style:({'background-image': ("url(" + _vm.photoURI + ")")})},[_c('div',{staticClass:"recipe-card__title",domProps:{"innerHTML":_vm._s(_vm.recipe.name)}})])}
var staticRenderFns = []

export { render, staticRenderFns }